import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Adarsh",
    lastName: "Balika",
    userName: "the_adarsh_balika",
    email: "adarshbalika@gmail.com",
    password: "adarshBalika123",
    bio: "Web Developer || Student || Blogger || Tech Enthusiast",
    websiteUrl: "adarshbalika.netlify.app",
    coverPic: "https://tinyurl.com/2zvza93a",
    profilePic: "https://tinyurl.com/j6v2eejb",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Ranganathan",
    lastName: "Madhavan",
    userName: "ActorMadhavan",
    email: "actorMadhavan123@gmail.com",
    password: "madhavan123",
    bio: "Actor-Love being one-Have lived a 100 lives within this one,thanks to the job-Made films-Some that you liked and yet others I indulged in-Blessed and fortunate.",
    websiteUrl: "imdb.com/name/nm0534856/",
    coverPic: "https://tinyurl.com/vtdes7tz",
    profilePic: "https://tinyurl.com/2p9724zh",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Nambi",
    lastName: "Narayanan",
    userName: "NambiNOfficial",
    email: "actorMadhavan123@gmail.com",
    password: "nambi@123",
    bio: "EX-ISRO Scientist.",
    websiteUrl: "",
    coverPic: "https://tinyurl.com/vtdes7tz",
    profilePic: "https://tinyurl.com/2syjpmyd",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Narendra",
    lastName: "Modi",
    userName: "narendramodi",
    email: "nmpmo@gmail.com",
    password: "narendra12345",
    bio: "Prime Minister of India",
    websiteUrl: "narendramodi.in",
    coverPic: "https://tinyurl.com/2p8fp5cf",
    profilePic: "https://tinyurl.com/yc4kzvs4",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Tanay",
    lastName: "Pratap",
    userName: "tanaypratap",
    email: "tanay@gmail.com",
    password: "tanay12345",
    bio: "Founder @invactHQ | x @Microsoft | Fixing education | Mentored 100 + students to first tech job | Tweets: Tech, Education, Career, Metaverse and Startups.",
    websiteUrl: "letters.tanaypratap.com",
    coverPic: "https://tinyurl.com/24mpx2yr",
    profilePic: "https://tinyurl.com/24bvpbzu",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Gaurav",
    lastName: "Taneja",
    userName: "flyingbeast320",
    email: "gaurav@gmail.com",
    password: "gaurav@123",
    bio: "Capt Airbus320, IIT KGP Alumni,Pro Bodybuilder, certified Nutritionist. Vlogger, Pursuing Law @ Faculty of Law, DU . Proud Indian",
    websiteUrl: "letters.tanaypratap.com",
    coverPic: "https://tinyurl.com/yc36fpy4",
    profilePic: "https://tinyurl.com/r4b68v7s",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Tanmay",
    lastName: "Bhat",
    userName: "thetanmay",
    email: "tanmay@gmail.com",
    password: "tanmay@123",
    bio: "Comedian, YouTuber, Investor. Building @SuperteamDAO",
    websiteUrl: "https://www.youtube.com/c/TanmayBhatYouTube/videos",
    coverPic: "https://tinyurl.com/2p5usnvf",
    profilePic: "https://tinyurl.com/4xbybcf5",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
